kimal.toggleMenu = function() {
  kimal.$hamburger.toggleClass('active');
  $('#main-nav__menu').toggleClass('visible');
}

kimal.$hamburger.on('click', function(e) {
  e.preventDefault();
  e.stopPropagation();

  kimal.toggleMenu();
});

$('body').on('click', function(e) {
  var $navMenu = $('#main-nav__menu');

  if (!$navMenu.hasClass('visible')) return;

  if (!$(e.target).is('#' + $navMenu.attr('id'))) {
    kimal.toggleMenu();
  }
})

//scroll
kimal.navScroll = {
	offsetTop: kimal.$mainNav.offset().top
}

kimal.$document.on('scroll', function(e) {
  if(e.type === 'scroll' && kimal.$window.width() > 1200) {
    if(kimal.$document.scrollTop() > kimal.navScroll.offsetTop) {
      kimal.$mainNav.addClass('sticky');
      kimal.$header.addClass('nav-fixed');
      kimal.$headerLogo.addClass('shrink');
      kimal.$hamburger.addClass('shrink');
    } else {
      kimal.$mainNav.removeClass('sticky');
      kimal.$header.removeClass('nav-fixed');
      kimal.$headerLogo.removeClass('shrink');
      kimal.$hamburger.removeClass('shrink');
    }
  }
});

$('#global-distribution-link').on('click', function(e) {
  var anchorElem = $('#global-distribution-anchor'),
  canScroll      = anchorElem.length > 0 ? true : false,
  offset         = anchorElem.offset().top,
  navHeight      = kimal.$mainNav.outerHeight();

  if(canScroll) {
    e.preventDefault();
    kimal.$pageElems.animate({
      scrollTop: (offset - navHeight)
   }, 500, 'easeOutQuart');
  }
});
